<template>
    <div class="class-1">
      <!-- Header -->
      <app-header />
      <!-- Create Branch Form -->
      <div class="container mt-4">
        <div class="row">
          <div class="col-12">
            <h2>craete_new_branch</h2>
            <form @submit.prevent="handleCreateBranch">
              <!-- Name Input -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="name">branch_name</label>
                  <input type="text" class="form-control" id="name" v-model="form.name" placeholder="Enter Branch Name" required>
                </div>
              </div>
  
              <!-- Max Chairs Input -->
              <!-- <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="maxChairs">Max Chairs</label>
                  <input type="number" class="form-control" id="maxChairs" v-model="form.maxChairs" placeholder="Enter Max Chairs">
                </div>
              </div> -->
  
              <!-- All Chairs Input -->
              <!-- <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="allChairs">All Chairs</label>
                  <input type="number" class="form-control" id="allChairs" v-model="form.allChairs" placeholder="Enter All Chairs">
                </div>
              </div> -->
  
              <!-- ERP Customer Name Input -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="ERP_CustomerName">erp_customer_name</label>
                  <input type="text" class="form-control" id="ERP_CustomerName" v-model="form.ERP_CustomerName" placeholder="Enter ERP Customer Name">
                </div>
              </div>
  
              <!-- isPOS Checkbox -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="isPOS" v-model="form.isPOS">
                    <label class="form-check-label" for="isPOS">is_pos</label>
                  </div>
                </div>
              </div>
  
              <!-- Suspended Status Input -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="isSuspend">status</label>
                  <select class="form-control" id="isSuspend" v-model="form.isSuspend" required>
                    <option value="0">active</option>
                    <option value="1">suspended</option>
                  </select>
                </div>
              </div>
  
              <!-- Buttons -->
              <div class="form-row">
                <div class="form-group col-12 d-flex justify-content-between">
                  <button type="button" class="btn btn-secondary" @click="clearForm">Cancel</button>
                  <button type="submit" class="btn btn-primary">create_branch</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        form: {
          name: '',
          lat: '0', 
          lng: '0', 
          maxChairs: '',
          allChairs: '',
          ERP_CustomerName: '',
          isPOS: false, 
          isSuspend: 0,
        },
        currentDate: '',
        currentTime: '',
      };
    },
    mounted() {
      this.updateDateTime();
      this.startDateTimeUpdate();
    },
    methods: {
      updateDateTime() {
        const now = new Date();
        this.currentDate = now.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        });
        this.currentTime = now.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        });
      },
      startDateTimeUpdate() {
        setInterval(() => {
          this.updateDateTime();
        }, 1000);
      },
      async handleCreateBranch() {
        try {
          this.$root.isLoading = true; 
          this.loading = true;
          const token = localStorage.getItem('authToken');
          const appId = 1; 
  
          const payload = {
  appId: parseInt(appId),
  name: this.form.name,
  lat: this.form.lat.toString(), 
  lng: this.form.lng.toString(), 
  allChairs: this.form.allChairs.toString(), 
  maxChairs: this.form.maxChairs.toString(), 
  printLang: 1, 
  isSuspend: parseInt(this.form.isSuspend), 
  ERP_CustomerName: this.form.ERP_CustomerName,
  isPOS: this.form.isPOS, 
};


  
          const response = await fetch(`${this.$BASE_API_URL}/api/branches`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payload),
          });
          const data = await response.json();
  
          if (response.ok) {
            this.$toast.success('Branch created successfully!');
            this.$router.push('/branches'); 
          } else {
            this.$toast.error('Failed to create branch: ' + (data.message || 'Unknown error'));
          }
        } catch (error) {
          console.error('Error:', error);
          this.$toast.error('An error occurred. Please try again.');
        }
        finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
      },
      clearForm() {
        this.$router.go(-1);
        this.form = {
          name: '',
          lat: '0',
          lng: '0',
          maxChairs: '',
          allChairs: '',
          ERP_CustomerName: '',
          isPOS: false,
          isSuspend: 0,
        };
      },
    },
  };
  </script>
  
  <style scoped>
  /* Add your custom styles here */
  .class-1 {
    font-family: 'Poppins', sans-serif;
  }
  
  .logo_icon {
    width: 100px;
    height: auto;
  }
  
  .container {
    max-width: 800px;
    margin: 0 auto;
  }
  
  .form-control {
    margin-bottom: 1rem;
  }
  
  .btn-primary {
    background-color: #4caf50;
    border: none;
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .btn-primary:hover {
    background-color: #45a049;
  }
  
  .btn-secondary {
    background-color: #6c757d;
    border: none;
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .btn-secondary:hover {
    background-color: #5a6268;
  }
  
  .txtfooter {
    margin-top: 2rem;
  }
  </style>